import { createHTMLTransformer, } from '@aeaton/prosemirror-transformers';
import React, { useState } from 'react';
import { ChangeHandler } from './ChangeHandler';
import { EditorProvider } from './EditorProvider';
export var HtmlEditor = function (_a) {
    var schema = _a.schema, plugins = _a.plugins, value = _a.value, handleChange = _a.handleChange, debounce = _a.debounce, children = _a.children;
    var htmlTransformer = useState(function () {
        return createHTMLTransformer(schema);
    })[0];
    var initialDoc = useState(function () {
        return htmlTransformer.parse(value);
    })[0];
    return (React.createElement(EditorProvider, { plugins: plugins, doc: initialDoc },
        React.createElement(ChangeHandler, { transformer: htmlTransformer, handleChange: handleChange, debounce: debounce }),
        children));
};
